import React, { useState } from 'react';
import { outcomes } from '../data';
import { Typography, Container, Box } from '@mui/material';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';

import StyledButton from './StyledButton';
import ImageComponent from './ImageComponent';

const ResultsComponent = ({ primaryOutcomeId, navigate }) => {
    const [isLoadingPrimary, setIsLoadingPrimary] = useState(true);
    const primaryOutcome = outcomes.find(o => o.id === primaryOutcomeId);

    console.log("ResultsComponent rendering with Primary Outcome ID:", primaryOutcomeId);

    return (
        <>
            <Box>
                <ImageComponent
                    src={primaryOutcome.image}
                    alt={primaryOutcome.title + " - " + primaryOutcome.description}  // More descriptive alt text
                    isLoading={isLoadingPrimary}
                    setIsLoading={setIsLoadingPrimary}
                />
            </Box>
            <Container maxWidth="sm">
                <Box display="flex" flexDirection="column" alignItems="left" mx={4} mt={4} >
                    <Box mt={4}>
                        <Typography variant="caption" align="left">YOUR RESULTS</Typography>
                        <Typography variant="h3" align="left" gutterBottom>{primaryOutcome.title}</Typography>
                        <Typography variant="h5" align="left">{primaryOutcome.description}</Typography>
                    </Box>
                </Box>
                <Box mb={16}>
                    <Box mt={8} mx={4} align="left">
                        <StyledButton endIcon={<SendIcon />}>
                            {primaryOutcome.cta}
                        </StyledButton>
                    </Box>
                    <Box mt={4}>
                        <Button
                            variant="text"
                            fullWidth
                            sx={{
                                color: 'rgb(44, 42, 41)',
                                backgroundColor: 'transparent',
                                '&:hover': {
                                    backgroundColor: 'rgb(244, 244, 244)',
                                }
                            }} onClick={() => navigate('/')}
                            aria-label="Restart the quiz"
                        >
                            RESTART QUIZ
                        </Button>
                    </Box>
                </Box>
            </Container>
        </>
    );
};

export default ResultsComponent;
